// Textos e formatação da cobrança da academia (plano por academia, ver
// app/services/payments/org_billing.py). Fonte única pro "Minha academia",
// o banner do painel do professor e a tela Academias do admin, pra os três
// dizerem a mesma coisa sobre a mesma situação.

export const ORG_BILLING = {
  COURTESY: "cortesia",
  PAID: "em_dia",
  GRACE: "carencia",
  BLOCKED: "bloqueada",
};

export const INTERVAL_OPTIONS = ["weekly", "biweekly", "monthly", "bimonthly", "quarterly", "semiannual", "yearly"];

export const INTERVAL_LABELS = {
  weekly: "Semanal", biweekly: "Quinzenal", monthly: "Mensal", bimonthly: "Bimestral",
  quarterly: "Trimestral", semiannual: "Semestral", yearly: "Anual",
};

const INTERVAL_PER = {
  weekly: "por semana", biweekly: "por quinzena", monthly: "por mês", bimonthly: "por bimestre",
  quarterly: "por trimestre", semiannual: "por semestre", yearly: "por ano",
};

export function formatMoney(value) {
  return Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

// "2026-10-05" (data pura) ou ISO com hora -> "05/10/2026". Data pura é
// montada pelas partes: new Date("2026-10-05") é meia-noite UTC e, no fuso
// de Brasília, viraria o dia anterior.
export function formatDateBR(value) {
  if (!value) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("pt-BR");
}

export function formatPlanPrice(plan) {
  if (!plan) return "";
  return `${formatMoney(plan.amount)} ${INTERVAL_PER[plan.interval] || ""}`.trim();
}

/**
 * Resumo da situação pra exibir. tone: "ok" | "warn" | "danger" | "neutral".
 * audience: "member" (professor/gestor/dono) ou "admin".
 */
export function describeOrgBilling(billing, { audience = "member" } = {}) {
  if (!billing) return null;
  const price = formatPlanPrice(billing.plan);
  switch (billing.status) {
    case ORG_BILLING.PAID:
      if (billing.source === "manual") {
        return {
          tone: "ok",
          title: "Contrato em dia",
          detail: billing.paid_through ? `Pago até ${formatDateBR(billing.paid_through)}.` : "",
        };
      }
      return {
        tone: "ok",
        title: "Assinatura em dia",
        detail: [price, billing.paid_through && `próxima cobrança em ${formatDateBR(billing.paid_through)}`]
          .filter(Boolean).join(", ") + ".",
      };
    case ORG_BILLING.GRACE:
      if (!billing.paid_through) {
        return {
          tone: "warn",
          title: "Assinatura pendente",
          detail: `${price ? `Plano da academia: ${price}. ` : ""}Assine até ${formatDateBR(billing.grace_until)} para manter o acesso dos professores.`,
        };
      }
      return {
        tone: "warn",
        title: "Pagamento vencido",
        detail: `Venceu em ${formatDateBR(billing.paid_through)}. O acesso dos professores continua até ${formatDateBR(billing.grace_until)}.`,
      };
    case ORG_BILLING.BLOCKED:
      return {
        tone: "danger",
        title: "Assinatura vencida",
        detail: "Professores e gestores estão sem acesso à gestão dos alunos. Os alunos continuam treinando normalmente.",
      };
    default:
      return audience === "admin"
        ? { tone: "neutral", title: "Cortesia", detail: "Sem cobrança definida." }
        : null;
  }
}
